module.exports = __webpack_public_path__ + "img/img7.d264ea82.svg";